import classNames from 'classnames';

import styles from './textArea.module.scss';
interface ITextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  title?: string;
  errors?: string;
  touched?: boolean;
  description?: string;
  label?: string;
  labelClass?: string;
}

const TextArea = ({
  errors,
  touched,
  description,
  label,
  labelClass,
  ...props
}: ITextAreaProps) => {
  return (
    <>
      <div className={styles['text-area']}>
        <div className="mb-2">
          <div>
            <span className={classNames('fw-8 color-gray-1', labelClass)}>
              {' '}
              {label}
            </span>
            {props.required && <span className="color-red-3">*</span>}
          </div>
          <small className="py-1 m-0 text-sm color-gray-2">{description}</small>
        </div>

        <textarea
          {...props}
          className={classNames(
            touched && errors && styles['text-area__invalid'],
            touched && !errors && styles['text-area__valid'],
            props.className,
          )}
        />
        {Boolean(errors) && Boolean(touched) && (
          <>
            <div className="pt-1 text-sm">
              {/* <small className={styles['text-area__input-icon__invalid']}>
                <i className="icon-warning"></i> {errors}
              </small> */}
              <span className="text-xs text-red-500">
                <i className="icon-warning"></i> {errors}
              </span>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default TextArea;
